// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"610488c0","82":"7f3c587e","149":"f3b73596","501":"ef74b4b2"}[chunkId] + ".chunk.js";
};